module.exports = __webpack_public_path__ + "img/arrow_up-short.50157f74.svg";